<template>
  <div :class="parameter.filter === 'select' ? 'mt-2' : 'truncate mt-2'">
    <Combobox
      v-if="parameter.filter === 'select'"
      v-model="selectedIds"
      :options="parameter.values"
      :name="groupName"
      :multiple="true"
      variant="outline"
      dimension="tiny"
      input-class-name="placeholder:text-primary-light text-xs font-bold border border-primary-dark rounded-full"
      class-border="border rounded-full"
      :placeholder="$t('text-start-typing')"
      :aria-label="parameter.name"
    />
    <label v-else-if="parameter.filter === 'radio'" class="flex items-center cursor-pointer">
      <input
        :id="`${groupName}_value_${item.id}`"
        :name="groupName"
        type="radio"
        :value="item.id"
        :checked="item.value"
        class="w-6 h-6 text-bolder border-primary-dark focus:ring-0 focus:ring-offset-0"
        @click="emit('changed', !item.value)"
      >
      <span :class="['ms-2 text-base', isDetail ? 'text-bolder' : 'text-heading']">{{ item.name }}</span>
    </label>
    <Checkbox
      v-else
      :model-value="item.value"
      :name="`${groupName}_value_${item.id}`"
      :label="item.name"
      :is-detail="isDetail"
      variant="outline"
      class="w-full"
      @update:model-value="value => emit('changed', value)"
    />
  </div>
</template>

<script setup>
import Checkbox from "@components/ui/checkbox";
import Combobox from "@components/ui/combobox";

const emit = defineEmits(['changed']);
const props = defineProps({
  parameter: { type: Object, required: true },
  item: { type: Object, default: null },
  groupName: { type: String, required: true },
  isDetail: { type: Boolean, default: false }
});

const selectedIds = computed({
  get: () => props.parameter.values.filter(item => item.value).map(item => item.id),
  set: value => emit('changed', value)
});
</script>
